module.exports = __webpack_public_path__ + "static/media/att.SK-15KcaS-n4su2fz7DTos6xHvKxxwvMdBJqqMphi90-min.d5a6551c.jpg";